import { Container } from 'inversify';
import { Api as ApiBase } from '@edikk-edikk/ui';
import { API_BASE_NAME } from '#base/constants';
import { getApiBase } from '#base/api/api-base';
import { API_REVIEW_LIST_NAME } from '#reviewList/constants';
import { API_ADVERT_LIST_BY_DATE_NAME, API_ADVERT_LIST_BY_SERVICE_NAME } from '#advertList/constants';
import { getApiReviewList } from '#reviewList/api/api-review-list';
import { getApiAdvertListByDate } from '#advertList/api/by-date';
import { getApiAdvertListByService } from '#advertList/api/by-service';
import { API_PAGE_NAME } from '#page/constants';
import { getApiPage } from '#page/api/api-page';
import { API_POPULAR_CITIES_NAME } from '#baseHome/constants';
import { getApiPopularCities } from '#baseHome/api/api-popular-cities';

class Api extends ApiBase {
  constructor(diContainer: Container) {
    super(diContainer);

    this.apiList.set(API_BASE_NAME, getApiBase(diContainer));
    this.apiList.set(API_REVIEW_LIST_NAME, getApiReviewList(diContainer));
    this.apiList.set(API_ADVERT_LIST_BY_DATE_NAME, getApiAdvertListByDate(diContainer));
    this.apiList.set(API_ADVERT_LIST_BY_SERVICE_NAME, getApiAdvertListByService(diContainer));
    this.apiList.set(API_PAGE_NAME, getApiPage(diContainer));
    this.apiList.set(API_POPULAR_CITIES_NAME, getApiPopularCities(diContainer));
  }

  getApiBase(): ReturnType<typeof getApiBase> {
    return this.apiList.get(API_BASE_NAME);
  }

  getApiReviewList(): ReturnType<typeof getApiReviewList> {
    return this.apiList.get(API_REVIEW_LIST_NAME);
  }

  getApiAdvertListByDate(): ReturnType<typeof getApiAdvertListByDate> {
    return this.apiList.get(API_ADVERT_LIST_BY_DATE_NAME);
  }

  getApiAdvertListByService(): ReturnType<typeof getApiAdvertListByService> {
    return this.apiList.get(API_ADVERT_LIST_BY_SERVICE_NAME);
  }

  getApiPage(): ReturnType<typeof getApiPage> {
    return this.apiList.get(API_PAGE_NAME);
  }

  getApiPopularCities(): ReturnType<typeof getApiPopularCities> {
    return this.apiList.get(API_POPULAR_CITIES_NAME);
  }
}

export { Api };
